<template>
  <el-tooltip class="item" effect="dark" :content="$t('nav.help')" placement="top"><el-link v-if="url != false" :href="url" :underline="false" type="primary" target="_blank"><i class="el-icon-question"></i></el-link></el-tooltip>
</template>
<script>
import moment from 'moment'

export default {
  name: 'Help',
  props: ['help'],
  data: function() {
    return {
    }
  },
  computed: {
    url: function() {
      if (this.help != null)
        return this.help
      else
        return this.$route.meta.help
    }
  }
}
</script>